/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { errorActions, selectError } from "Features/error";
import { selectWallets } from "Features/wallets";
import { useDispatch, useSelector } from "react-redux";
import { selectWithdraw, withdrawActions } from "Shared/store/withdraw";
import { WithdrawModalsContext } from "./WithdrawModalContext";
import { walletsActions } from "Features/wallets";
import { balanceActions } from "Features/balance";
import { selectBalance } from "Features/balance/balance.select";

export const WithdrawModalsProvider = ({ children }) => {
	const dispatch = useDispatch();
	const method = useSelector(selectWithdraw.method);
	const addFetch = useSelector(selectWallets.addFetch);
	const succes = useSelector(selectWallets.succes);
	const isVisibleModal = useSelector(selectWithdraw.isVisibleAddMethod);
	const newWalletData = useSelector(selectWithdraw.wallet);
	const withdraw_status = useSelector(selectBalance.withdraw_status);
	const [prevFetch, setPrevFetch] = useState(null);
	const errorPage = useSelector(selectError.page);
	const errorMessage = useSelector(selectError.message);
	const [errors, setErrors] = useState({});
	const updateData = useSelector(selectWithdraw.wallet);

	useEffect(() => {
		if (prevFetch && !addFetch) {
			if (succes) dispatch(withdrawActions.setVisibleUpdateAcc(false));
			if (!succes) errorHandler();
		}
		setPrevFetch(addFetch);
	}, [addFetch]);
	useEffect(() => {
		if (withdraw_status == "success") {
			dispatch(withdrawActions.setVisibleUpdateAcc(false));
			dispatch(withdrawActions.setWallet(null));
		}
		if (withdraw_status == "error") {
			errorHandler();
		}
	}, [withdraw_status]);

	function errorHandler() {
		if (errorPage === "add_wallet") {
			const iban = errorMessage.filter((m) => m.includes("iban"));
			const paypal_email = errorMessage.filter((m) => m.includes("paypal_email"));
			const first_name = errorMessage.filter((m) => m.includes("first_name"));
			const last_name = errorMessage.filter((m) => m.includes("last_name"));
			const country_id = errorMessage.filter((m) => m.includes("country_id"));
			const province = errorMessage.filter((m) => m.includes("province"));
			const address = errorMessage.filter((m) => m.includes("address"));
			const birthdate = errorMessage.filter((m) => m.includes("birthdate"));
			const postcode = errorMessage.filter((m) => m.includes("postcode"));
			const alredy_registered = errorMessage.filter((m) => m.includes("already_registered"));
			const personal_id = errorMessage.filter((m) => m.includes("personalid"));
			const inputErrors = {};
			if (iban.length) inputErrors.iban = iban;
			if (paypal_email.length) inputErrors.paypal_email = paypal_email;
			if (first_name.length) inputErrors.first_name = first_name;
			if (last_name.length) inputErrors.last_name = last_name;
			if (country_id.length) inputErrors.country_id = country_id;
			if (province.length) inputErrors.province = province;
			if (address.length) inputErrors.address = address;
			if (birthdate.length) inputErrors.birthdate = birthdate;
			if (postcode.length) inputErrors.postcode = postcode;
			if (alredy_registered.length) inputErrors.alredy_registered = alredy_registered;
			if (personal_id.length) inputErrors.personal_id = personal_id;
			setErrors(inputErrors);

			if (iban.length || paypal_email.length || alredy_registered.length) {
				dispatch(withdrawActions.setVisibleAddMethod(true));
				dispatch(withdrawActions.setVisibleUpdateAcc(false));
			}
		}
	}
	function onCancelCreate() {
		dispatch(withdrawActions.drop());
		setErrors({});
		if (errorPage === "add_wallet") {
			dispatch(errorActions.drop());
		}
	}

	function onConfirmCreate() {
		if (method === "iban") {
			if (!validateIBAN(newWalletData.iban)) {
				const newErrors = { ...errors, iban: "invalid IBAN" };
				setErrors(newErrors);
				return;
			}
		}

		if (method === "paypal") {
			if (!validatePayPalEmail(newWalletData.paypal_email)) {
				const newErrors = { ...errors, paypal_email: "invalid paypal" };
				setErrors(newErrors);
				return;
			}
		}

		dispatch(withdrawActions.setVisibleAddMethod(false));
		dispatch(withdrawActions.setVisibleUpdateAcc(true));
	}

	function onChangeWalletData(key, value) {
		dispatch(withdrawActions.updateWallet({ key, value }));
		const newErrors = { ...errors };
		if (errors[key]) {
			delete newErrors[key];
		}
		if (key === "country_id") {
			delete newErrors["address"];
			delete newErrors["postcode"];
			delete newErrors["personal_id"];
		}
		if ((key === "iban" || key === "paypal_email") && newErrors.alredy_registered) {
			delete newErrors.alredy_registered;
		}

		setErrors(newErrors);
	}

	function onOk() {
		const validateError = validateReuiredFields(newWalletData);
		if (Object.keys(validateError).length) {
			setErrors(validateError);
			return;
		}
		if (!updateData?.id) {
			dispatch(walletsActions.addReq({ method, data: newWalletData }));
			return;
		}
		if (updateData.id) {
			dispatch(balanceActions.withdrawReq());
			return;
		}
	}
	function onCancelUpdate() {
		const isUpdate = updateData?.id;
		dispatch(withdrawActions.setVisibleUpdateAcc(false));
		if (isUpdate) {
			return;
		}
		dispatch(withdrawActions.setVisibleAddMethod(true));
	}

	function onWithdraw() {
		dispatch(withdrawActions.setVisibleUpdateAcc(true));
	}

	return (
		<WithdrawModalsContext.Provider
			value={{
				isVisible: isVisibleModal,
				onCancelCreate,
				onChangeWalletData,
				onConfirmCreate,
				newWalletData,
				method,
				errors,
				onOk,
				onWithdraw,
				onCancelUpdate,
				isUpdate: !!updateData?.id,
			}}
		>
			{children}
		</WithdrawModalsContext.Provider>
	);
};

function validateReuiredFields(data) {
	let errors = {};

	const isLatvia = data.country_id === 428;

	if (isLatvia) {
		if (!validateLatvianPersonalId(data.personal_id)) {
			errors["personal_id"] = "invalid personal id";
		}
	}
	if (!isLatvia) {
		if (!data.address) errors["address"] = "empty address";
		if (!data.postcode) errors["postcode"] = "empty postcode";
		if (!data.address) errors["address"] = "empty address";
	}
	return errors;
}

function validateIBAN(iban) {
	try {
		// Удаляем пробелы и возможные разделители
		iban = iban.replace(/[^A-Z0-9]/gi, "");

		// Перемещаем первые 4 символа в конец IBAN
		iban = iban.slice(4) + iban.slice(0, 4);

		// Заменяем каждую букву на две цифры
		iban = iban.replace(/[A-Z]/g, (letter) => {
			return letter.charCodeAt(0) - 55;
		});

		// Выполняем модульное деление на 97
		let remainder = BigInt(iban) % BigInt(97);

		return remainder === 1n;
	} catch (error) {
		return false;
	}
}

function validatePayPalEmail(email) {
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return emailRegex.test(email);
}

function validateLatvianPersonalId(id) {
	// Проверяем формат от 2017года (32XXXXXXXXX)
	const pattern2017 = /^32\d{9}$/;
	if (pattern2017.test(id)) {
		return true;
	}
	// Проверяем старый формат (DDMMYY-XXXXX)
	const pattern = /^\d{6}-\d{5}$/;
	if (!pattern.test(id)) {
		return false;
	}

	// Разделяем ID на дату рождения и суффикс
	// eslint-disable-next-line no-unused-vars
	const [birthdate, suffix] = id.split("-");

	// Проверяем дату рождения
	const day = parseInt(birthdate.substring(0, 2), 10);
	const month = parseInt(birthdate.substring(2, 4), 10);
	const year = parseInt(birthdate.substring(4, 6), 10);
	const currentYear = new Date().getFullYear() % 100;
	const fullYear = year > currentYear ? year + 1900 : year + 2000;

	if (!isValidDate(day, month, fullYear)) {
		return false;
	}

	return true;
}

function isValidDate(day, month, year) {
	const date = new Date(year, month - 1, day);
	return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}
